import React, { useState } from 'react';
import './Contact.css';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa'; // Icon import
import logo from '../../assets/images/logo1.png'; 

const Contact = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [result, setResult] = useState(""); // Status handling

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setResult("");
  };

  // Web3Forms Submit Function (Common for both forms)
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    // Your Access Key
    formData.append("access_key", "68f8c92b-95f6-4539-bca9-456711228405");
    formData.append("subject", "New Inquiry from Contact Page");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Message Sent Successfully!");
      event.target.reset();
      if (isModalOpen) {
        setTimeout(() => closeModal(), 2500);
      }
    } else {
      setResult(data.message);
    }
  };

  const containerVariants = {
    hidden: { opacity: 0, y: -80 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { 
        duration: 0.8, 
        staggerChildren: 0.2,
        ease: [0.175, 0.885, 0.32, 1.275] 
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 30 },
    visible: { 
      opacity: 1, 
      scale: 1, 
      y: 0,
      transition: { type: "spring", stiffness: 120, damping: 12 }
    }
  };

  return (
    <motion.section 
      id="contact" 
      className="contact-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.1 }}
      variants={containerVariants}
    >
      <div className="container">
        <motion.div className="section-header" variants={itemVariants}>
          <div className="linee"></div>
          <h2 className="section-title">Contact Us</h2>
          <div className="linee"></div>
        </motion.div>

        <div className="contact-wrapper">
          <motion.div className="contact-info" variants={itemVariants}>
            <div className="info-card">
              <div className="card-row">
                <div className="icon-circle">📞</div>
                <div className="card-text">
                  <h3>Call Us</h3>
                  <p>+91 9371320616</p>
                </div>
              </div>
            </div>
            
            <a href="https://wa.me/919371320616" target="_blank" rel="noreferrer" className="info-card whatsapp-card">
              <div className="card-row">
                <div className="icon-circle whatsapp-icon-bg">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WA" />
                </div>
                <div className="card-text">
                  <h3>Whatsapp</h3>
                  <p>+91 9371320616</p>
                </div>
              </div>
            </a>
          </motion.div>

          {/* Main Page Contact Form */}
          <motion.div className="contact-form-container" variants={itemVariants}>
            <form className="contact-form" onSubmit={onSubmit}>
              <input type="text" name="name" placeholder="Your Name" required />
              <input type="tel" name="mobile" placeholder="Phone No" required />
              <input type="email" name="email" placeholder="Your Email" required />
              
              <div className="privacy-note">
                <span className="lock-icon">🔒</span>
                Your information is secure with us.
              </div>
              
              <button type="submit" className="submit-btn">Submit Inquiry</button>
              {result && !isModalOpen && <p className="form-status">{result}</p>}
            </form>
          </motion.div>
        </div>
      </div>

      {/* --- FORM MODAL (Global Consistency) --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            
            <div className="modal-content">
              <div className="modal-logo">
                <img src={logo} alt="Logo" />
              </div>
              <h2 className="enquire-title">Enquire Now</h2>
              
              <form className="modal-form" onSubmit={onSubmit}>
                <input type="text" name="first_name" placeholder="First Name" required />
                <input type="text" name="last_name" placeholder="Last Name" required />
                <input type="email" name="email" placeholder="Email Id" required />
                <input type="tel" name="mobile" placeholder="Mobile No." required />
                
                {/* <select name="project" required className="modal-select">
                  <option value="" disabled selected>Select Project</option>
                  <option value="Sentosa Era">Sentosa Era</option>
                </select> */}

                <div className="checkbox-container">
                  <input type="checkbox" id="contact-consent" name="consent" required />
                  <label htmlFor="contact-consent">
                    I hereby authorize to send notification on SMS, Calls, RCS, WhatsApp.
                  </label>
                </div>

                <button type="submit" className="modal-submit-btn">
                  SUBMIT NOW <FaArrowRight style={{marginLeft: '8px'}} />
                </button>
              </form>

              {result && <p className="form-status">{result}</p>}
            </div>
          </div>
        </div>
      )}
    </motion.section>
  );
};

export default Contact;